import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { OndemandVideo } from '@mui/icons-material';
import { CardMedia } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    boxShadow: 24,
    p: 1,
};

type VideoKey = 'GENERAL' | 'CASE' | 'POST_JOB' | 'WATCHLISTS' | 'GROUPS' | 'INTEGRATIONS';

type VideoHelpModalProps = {
    videoKey: VideoKey;
};

export const videoUrls: Array<{ key: VideoKey; url: string; title: string }> = [{
    key: 'GENERAL',
    url: 'https://www.youtube-nocookie.com/embed/CLlj4xipeWY?feature=oembed',
    title: 'Så funkar Logic Link'
}, {
    key: 'CASE',
    url: 'https://www.youtube-nocookie.com/embed/hnEvK67K2iU?feature=oembed',
    title: 'Smartare planering'
}, {
    key: 'POST_JOB',
    url: 'https://www.youtube-nocookie.com/embed/gQ4vDqVR4pg?feature=oembed',
    title: 'Publicera uppdrag'
}, {
    key: 'WATCHLISTS',
    url: 'https://www.youtube-nocookie.com/embed/rztuIGVNzVk?feature=oembed',
    title: 'Bevakningar'
}, {
    key: 'GROUPS',
    url: 'https://www.youtube-nocookie.com/embed/5ldyRX7uKno?feature=oembed',
    title: 'Grupper'
}, {
    key: 'INTEGRATIONS',
    url: 'https://www.youtube-nocookie.com/embed/3fkTQtbDs2g?feature=oembed',
    title: 'Integrationer'
}];

export default function VideoHelpModal({ videoKey }: VideoHelpModalProps) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const video = videoUrls.find((v) => v.key === videoKey);
    return !video ? null : (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    '&:hover': { backgroundColor: 'transparent' }
                }}
            >
                <OndemandVideo />
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CardMedia
                        component="iframe"
                        src={video.url}
                        title={video.title}
                        allowFullScreen
                        sx={{
                            width: '100%',
                            height: 450,
                            border: 'none',
                            borderRadius: 2,
                            padding: 3,
                            allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                        }}
                    />
                </Box>
            </Modal>
        </>
    );
}
